/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React, { useEffect, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object, string, func, bool, number,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { Fade, Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import { useUIDSeed } from 'react-uid';
import ReactHtmlParser from 'react-html-parser';
import LazyLoad from 'react-lazyload';
import Slider from 'react-slick';
import { clubComponentType, selectedSkuType, productType } from '../common/types';
import ProductNameRender from '../common/ProductNameRender/index';
import { snipePath, isSnipeImageActive } from '../common/commonProductPageHelper';
import SnipeRender from '../common/SnipeRender';
import SnipeRenderQuery from '../common/SnipeRenderQuery';
import ProductImageZoomingUI from '../ProductImageUI/v2/ProductImageZoomingUI';

const styles = (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        background: theme?.palette?.white,
        [theme?.breakpoints?.down('md')]: {
            flexDirection: 'column',
            justifyContent: 'flex-start',
        },
    },
    monthList: {
        display: 'flex',
    },
    monthDetailContainer: {
        display: 'flex',
        position: 'relative',
        margin: '0 auto',
        maxWidth: 1080,
    },
    leftNav: {
        marginTop: '100px',
        border: '0',
        cursor: 'pointer',
        transform: 'rotate(90deg)',
        background: 'transparent',
        height: 'fit-content',
        '&:focus': {
            outline: 'none', // TODO: Need to add outline for accessibility
        },
    },
    flexContainer: {
        display: 'flex',
    },
    productImageWrapperMonth: {
        flex: '1 1 auto',
        width: '100%',
        height: '100%',
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            order: '1',
        },
    },
    productImage: {
        width: '100%',
        height: 'auto',
        aspectRatio: '138/151',
        [theme?.breakpoints?.down('md')]: {
            height: 'auto',
        },
    },
    monthDescriptionSummary: {
        width: '100%',
        [theme.breakpoints.down('md')]: {
            marginLeft: '0px',
            minWidth: '254px',
        },
    },

    nextNav: {
        marginTop: '100px',
        border: '0',
        cursor: 'pointer',
        transform: 'rotate(-90deg)',
        background: 'transparent',
        height: 'fit-content',
        '&:focus': {
            outline: 'none', // TODO: Need to add outline for accessibility
        },
    },
    productImageWrapperClub: {
        display: 'inline-block',
        margin: '0',
        minWidth: '200px',
        maxWidth: '600px',
        height: '100%',
        position: 'relative',
        [theme?.breakpoints?.down('md')]: {
            marginLeft: '20px',
        },
        [theme?.breakpoints?.down('sm')]: {
            marginLeft: 0,
            maxWidth: '100%',
        },
    },
    imageContainer: {
        position: 'relative',
        cursor: 'pointer',
        '& $productImage': {
            [theme?.breakpoints?.down(960)]: {
                margin: '10px 0px',
            },
        },
    },
    productImageWrapper: {
        flex: '1 1 auto',
        order: '2',
        maxWidth: '600px',
        height: '100%',
        position: 'relative',
        [theme?.breakpoints?.down('md')]: {
            order: '1',
        },
    },
    snipe: {
        position: 'absolute',
        bottom: '4px',
        right: '0',
        left: '0',
        width: '100%',
    },
    prevLink: {
        transform: 'rotate(90deg)',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        boxSizing: 'border-box',
        color: theme.palette.desktopHeaderMenu?.text || '#333333',
        textAlign: 'center',
        lineHeight: 'normal',
        '&:focus': {
            outline: 'none', // TODO: Need to add outline for accessibility
        },
    },
    nextLink: {
        transform: 'rotate(-90deg)',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        boxSizing: 'border-box',
        color: theme.palette.desktopHeaderMenu?.text || '#333333',
        textAlign: 'center',
        lineHeight: 'normal',
        '&:focus': {
            outline: 'none', // TODO: Need to add outline for accessibility
        },
    },
    monthSnipe: {
        position: 'absolute',
        right: 0,
        left: 0,
        bottom: 0,
        padding: 5,
        backgroundColor: 'rgba(47,47,47, .9)',
        boxSizing: 'border-box',
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        textAlign: 'center',
    },
    upsellSelected: {
        '& span': {
            backgroundColor: theme.palette.primaryButton || '#a1001a',
        },
    },
    upsellImageBox: {
        display: 'inline-block',
        flexWrap: 'wrap',
        marginRight: '10px',
        maxWidth: '110px',
        [theme.breakpoints.down('md')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'flex',
            maxWidth: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            order: '2',
            margin: '20px 0 0 0',
            display: 'inline-block',
            maxWidth: '100%',
        },
        '&:hover span': {
            backgroundColor: theme.palette.primaryButton || '#a1001a',
        },
        '&:last-child': {
            margin: 0,
        },
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        '& .slick-list': {
            display: 'none',
        },
        [theme.breakpoints.down('md')]: {
            width: '92%',
            margin: '0 auto',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            display: 'block',
            margin: '0 auto',
            '& .slick-list': {
                overflow: 'hidden',
                margin: '0 auto',
                display: 'block',
                width: '100%',
            },
            '& .slick-slide': {
                float: 'left',
                whiteSpace: 'nowrap',
            },

        },
    },
    clubLengthHeadline: {
        color: theme.palette.cms?.primary_font_color || '#ffffff',
        position: 'absolute',
        textAlign: 'center',
        backgroundColor: 'rgba(47,47,47, .9)',
        bottom: '0px',
        right: '0',
        left: '0',
        padding: '5px',
        [theme.breakpoints.down(960)]: {
            padding: '10px',
        },
        '&:hover': {
            backgroundColor: theme.palette.cms?.primary || '#a1001a',
        },
    },
    dialogContentRoot: {
        padding: 0,
    },
    dialogMain: {
        backgroundColor: theme.palette.cms?.clubComponentBackground || 'rgba(47,47,47,1)',

    },
    dialogContentArea: {
        margin: '0 5px',
        background: theme.palette.cms?.primary_font_color || '#ffffff',
        height: '100%',
    },
    dialogContent: {
        padding: '0 5px',
    },
    closeIcon: {
        position: 'absolute',
        top: '13px',
        right: '13px',
        cursor: 'pointer',
    },
    block: {
        display: 'block',
    },
    sliderDialog: {
        margin: '0 5px',
        height: 'auto',
        '& .slick-track': {
            display: 'flex',
        },
        '& .slick-slide': {
            height: 'inherit',
        },
        '& .slick-slide > div': {
            height: '100%',
        },
    },
    textCenter: {
        textAlign: 'center',
        padding: 5,
    },
    headerColor: {
        color: theme.palette.cms?.primary_font_color || '#ffffff',
    },
    headerFontSize: {
        fontSize: 18,
        verticalAlign: 'top',
    },
    componentList: {
        padding: '0 5px',
    },
    componentName: {
        color: theme.palette.cms?.clubComponentsName || '#2f2f2f',
        margin: '0',
        display: '-webkit-box',
        overflow: 'hidden',
        fontSize: '1em',
        textAlign: 'center',
        maxHeight: '48px',
        lineHeight: '1.6em',
        fontWeight: '500',
        textOverflow: 'ellipsis',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: '2',
        whiteSpace: 'normal',
    },
    componentLengthSpacer: {
        borderTop: `1px solid ${theme.palette.cms?.clubComponentsNameBorder || 'rgba(0,0,0,.24)'}`,
        height: 1,
        width: '100%',
        marginTop: 15,
    },
    sliderContainer: {
        '& .slick-track': {
            transition: 'all 0.8s ease 0s',
        },
    },
    clubPDPV2Wrapper: {
        '& $clubLengthHeadline': {
            display: 'none',
        },
        '& $textCenter': {
            display: 'none',
        },
    },
    productNameContainer: {
        paddingTop: '16px',
    },
});

const ClubPDPImageMobile = ({
    classes,
    modalOpen,
    handleState,
    product,
    clubComponents,
    renderZoom,
    shouldRenderSnipe,
    getClubLengthDescription,
    presentation_family,
    renderSnipe,
    heroImage,
    personalizationFlag,
    selectedSku,
    cdnLink,
    productUrl,
    selectedComponentMonth,
    showSnipeImage,
    isClubPDPV2,
    productImage,
}) => {
    const seed = useUIDSeed();
    const sliderMobileRef = useRef();
    useEffect(() => {
        if (sliderMobileRef?.current) {
            sliderMobileRef.current.slickGoTo(0);
        }
    }, [clubComponents]);
    return (
        <div className={classes.root}>
            <Dialog
                fullScreen
                open={modalOpen}
                maxWidth={false}
                PaperProps={{ className: classes.dialogMain }}
                onClose={() => { handleState({ modalOpen: false, selectedComponentMonth: null }); }}
            >
                <DialogTitle className={classes.headerColor}>
                    <span className={classes.headerFontSize}>ITEM DESCRIPTIONS </span> <CloseIcon data-testid="club-component-detail-modal-close" onClick={() => { handleState({ modalOpen: false, selectedComponentMonth: null }); }} className={classes.closeIcon} />
                </DialogTitle>
                <DialogContent className={classes.dialogContentRoot}>
                    <div data-testid="club-component-detail-modal" className={classes.block}>
                        <Slider
                            dots={false}
                            centerMode
                            centerPadding="15px"
                            infinite={false}
                            speed={500}
                            adaptiveHeight
                            slidesToShow={1}
                            slidesToScroll={1}
                            initialSlide={selectedComponentMonth}
                            nextArrow={(<></>)}
                            prevArrow={(<></>)}
                            className={`carousel-container ${classes.sliderDialog}`}
                        >
                            {(clubComponents || []).map((component) => (
                                <React.Fragment key={seed(component)}>
                                    <div className={classes.dialogContentArea}>
                                        <img
                                            className={classes.productImage}
                                            src={`${cdnLink}${component.image?.name}${'x.jpg'}`}
                                            alt={ReactHtmlParser(component.name)}
                                        />
                                        <div className={classes.dialogContent}>
                                            <div className={classes.textCenter}>
                                                <b>{component.month}</b>
                                                <br />
                                                <b>{ReactHtmlParser(component.name)}</b>
                                            </div>
                                            <ReactMarkdown
                                                source={component.longDescription || ''}
                                                escapeHtml={false}
                                            />
                                            <ReactMarkdown
                                                source={component.productContents || ''}
                                                escapeHtml={false}
                                            />
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))}
                        </Slider>
                    </div>
                </DialogContent>
            </Dialog>
            <div className={isClubPDPV2 ? `${classes.clubPDPV2Wrapper} ${classes.productImageWrapperClub}` : classes.productImageWrapperClub}>
                <div
                    onClick={() => { if (!isClubPDPV2) { handleState({ modalOpen: true, selectedComponentMonth: 0 }); } }}
                    onKeyDown={() => { }}
                    role="button"
                    tabIndex="0"
                    className={classes.imageContainer}
                    data-testId="pdp-image"
                >
                    {renderZoom()
                        ? (
                            <ProductImageZoomingUI
                                imagePath={heroImage}
                                data={product}
                                classes={classes}
                                isRenderSnipe={renderSnipe && showSnipeImage}
                                personalizationFlag={personalizationFlag}
                            />
                        ) : (
                            <img src={heroImage} alt={product?.name} className={classes?.productImage} />
                        )}
                    {presentation_family === 'food' && showSnipeImage && renderSnipe && shouldRenderSnipe(product?.image?.snipe, personalizationFlag) && isSnipeImageActive(product?.image, 'pdp') /* data?.image && data?.image.snipe */ ? ( // if snipe data exsist display snipe img
                        <LazyLoad>
                            <Fade in timeout={700}>
                                <SnipeRender
                                    altText={product?.image?.altText}
                                    styleProp={classes.snipe}
                                    src={`${product?.image?.snipeImagePath}${product?.image?.snipe}_z.gif`}
                                    fallbackSrc={`${snipePath(product.image.path)}${product?.image?.snipe}_z.gif`}
                                />
                            </Fade>
                        </LazyLoad>
                    ) : null}
                    {showSnipeImage &&  <SnipeRenderQuery  partNumber={product?.partNumber}  productType="product" />}
                    {getClubLengthDescription() && (
                        <div className={classes.clubLengthHeadline}>
                            {getClubLengthDescription()}
                        </div>
                    )}
                </div>
                <div className={classes.flexCenter}>
                    <Grid container>
                        {!isClubPDPV2 && (
                            <Grid xs={12} item>
                                <ProductNameRender
                                    product={product}
                                    selectedSku={selectedSku}
                                    productUrl={productUrl}
                                    isClubProduct
                                />
                            </Grid>
                        )                        }
                        <Grid xs={12} item key={seed(clubComponents)}>
                            <Slider
                                dots={false}
                                infinite={false}
                                speed={500}
                                slidesToShow={isClubPDPV2 ? 4.5 : 2.5}
                                slidesToScroll={2}
                                nextArrow={(<></>)}
                                prevArrow={(<></>)}
                                className={`carousel-container ${classes.sliderContainer}`}
                                ref={sliderMobileRef}
                            >
                                {(clubComponents || []).map((component, index) => (
                                    <React.Fragment key={seed(component)}>
                                        <div
                                            data-testid={`component-${index}`}
                                            className={classes.componentList}
                                            onClick={() => {
                                                if (!isClubPDPV2) {
                                                    handleState({ modalOpen: true, selectedComponentMonth: index });
                                                } else {
                                                    productImage(component.image?.name);
                                                }
                                            }}
                                            onKeyDown={() => { }}
                                            role="link"
                                            tabIndex="0"
                                        >
                                            <img
                                                className={classes.productImage}
                                                src={`${cdnLink}${component.image?.name}${'t.jpg?width=282&height=315&auto=webp'}`}
                                                alt={ReactHtmlParser(component.name)}
                                            />
                                            <div className={classes.textCenter}>
                                                {component.month}
                                                <br />
                                                <span className={classes.componentName}>{ReactHtmlParser(component.name)}</span>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ))}
                            </Slider>
                        </Grid>
                        {isClubPDPV2 && (
                            <Grid xs={12} item className={classes.productNameContainer}>
                                <ProductNameRender
                                    product={product}
                                    selectedSku={selectedSku}
                                    productUrl={productUrl}
                                    isClubProduct
                                />
                            </Grid>
                        )}
                    </Grid>
                    <div className={classes.componentLengthSpacer} />
                </div>
            </div>
        </div>
    );
};

ClubPDPImageMobile.defaultProps = {
    modalOpen: false,
    handleState: () => { },
    selectedSku: {},
    product: {},
    renderZoom: () => { },
    shouldRenderSnipe: () => { },
    getClubLengthDescription: () => { },
    presentation_family: 'food',
    renderSnipe: func,
    heroImage: '',
    personalizationFlag: false,
    clubComponents: [],
    cdnLink: '',
    productUrl: '',
    selectedComponentMonth: 0,
    showSnipeImage: false,
    isClubPDPV2: false,
    productImage: () => {},
};

ClubPDPImageMobile.propTypes = {
    classes: object.isRequired,
    cdnLink: string,
    clubComponents: clubComponentType,
    modalOpen: bool,
    handleState: func,
    product: productType,
    selectedSku: selectedSkuType,
    renderZoom: func,
    shouldRenderSnipe: func,
    getClubLengthDescription: func,
    presentation_family: string,
    renderSnipe: func,
    heroImage: string,
    personalizationFlag: bool,
    productUrl: string,
    selectedComponentMonth: number,
    showSnipeImage: bool,
    isClubPDPV2: bool,
    productImage: func,
};

export default (withStyles(styles)(ClubPDPImageMobile));
